import _ from "lodash";
/**-- external -- */
import React from "react";
import { Avatar } from "@toddle-edu/ds-web";

/**-- internal -- */
import { AVATAR_COLORS } from "Constants/colorConstants";
import { hashString } from "Utils";
import { getAcronym } from "Course/routes/Settings/modules/SettingsUtils";

/**--relative-- */
import classes from "./CourseIcon.scss";
import { getAvatarData } from "LearningCourses/modules/Utils";
import { getOutlinedIconComponent } from "Login/routes/Administrator/modules/Utils";

//TODO: Can we treat this as a pure UI component?
const CourseIcon = ({
  course,
  isLearningCoursesEnabled,
  isLearningCoursesFeed,
}) => {
  const { title } = course;

  const profileImageData = isLearningCoursesFeed
    ? _.get(course, "displayMetadata")
    : _.get(course, "profileImageData");

  if (!isLearningCoursesEnabled) {
    const avatarColor =
      AVATAR_COLORS[hashString(course.id) % AVATAR_COLORS.length];

    const avatarElement = (
      <Avatar
        shade={"light"}
        color={avatarColor}
        name={getAcronym(title)}
        size={"medium"}
        shape="square"
        className={classes.acronymBox}
        src={profileImageData?.url}
        dsVersion="2.0"
      />
    );

    if (profileImageData?.icon) {
      const icon = getOutlinedIconComponent({
        icon: profileImageData?.icon,
        size: "medium",
        className: classes.acronymBox,
      });
      return <div className={classes.courseProfileImageIcon}>{icon}</div>;
    }
    return (
      <div className={classes.courseProfileImageAvatar}>{avatarElement}</div>
    );
  } else {
    const { color, name, AvatarIcon, iconType } = getAvatarData({
      id: course.id,
      title,
      profileImageData,
    });

    return (
      <div className={classes.courseProfileImageAvatar}>
        <Avatar
          icon={<AvatarIcon size="medium" />}
          color={color}
          name={name}
          iconType={iconType}
          size="small"
          shape="square"
          theme="light"
          dsVersion="2.0"
          className={classes.acronymBox}
        />
      </div>
    );
  }
};

export default CourseIcon;
